export default "__VITE_ASSET__Bny_Q9Rr__"